module.exports = __webpack_public_path__ + "img/general-bg-6.c74aaa71.svg";